export const JOB_STATUS = {
  DRAFT: 'Draft',
  IN_PROGRESS: 'In Progress',
  CLOSED: 'Closed',
};

export const TEMPLATE_STATUS = {
  DRAFT: 'Draft',
  ACTIVE: 'Active',
};

export const DEFAULT_STATUS_FILTERS = {
  publisher: [],
  inspector: [JOB_STATUS.IN_PROGRESS],
  report: [JOB_STATUS.IN_PROGRESS, JOB_STATUS.CLOSED],
  editor: [],
};

export const getEffectiveJobStatus = (jobOrStatus, tool) => {
  if (!jobOrStatus) {
    return tool === 'editor' ? TEMPLATE_STATUS.DRAFT : JOB_STATUS.DRAFT;
  }

  if (typeof jobOrStatus === 'string') {
    return jobOrStatus;
  }

  if (jobOrStatus.status) {
    return jobOrStatus.status;
  }

  if (tool === 'editor') {
    return TEMPLATE_STATUS.DRAFT;
  }

  if (
    jobOrStatus.jobCompleted === true ||
    String(jobOrStatus.workStatusCode || '') === '2'
  ) {
    return JOB_STATUS.CLOSED;
  }

  return JOB_STATUS.DRAFT;
};

export const isJobEditableByStatus = (jobOrStatus, tool) => {
  const status = getEffectiveJobStatus(jobOrStatus, tool);

  if (tool === 'editor') {
    return true;
  }

  if (tool === 'publisher') {
    return status !== JOB_STATUS.CLOSED;
  }

  if (tool === 'inspector' || tool === 'report') {
    return status === JOB_STATUS.IN_PROGRESS;
  }

  return false;
};
